import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { BrandLogo } from '../brandLogo/brandLogo';
import { Title } from '../title/title';
import { useStyles } from '../../../../common/hooks/useStyles';
import { getLogoAndTitleStyleObject } from './logoAndTitle.style';
import { adsDataSelector } from '../../../../common/store/selectors/adsData.selector';

export const LogoAndTitle: FunctionComponent = () => {
  const isVastAd = useSelector(adsDataSelector.isVastAd);
  const adBreak = useSelector(adsDataSelector.adBreak);

  const styles = useStyles(getLogoAndTitleStyleObject, []);
  const { titleAndLogoStyle } = styles;
  const showAdControls = isVastAd && adBreak;
  return showAdControls ? null :
    (
      <div style={titleAndLogoStyle}>
        <BrandLogo />
        <Title />
      </div>
    );
};
